export default __webpack_public_path__ + "static/media/chevronUp.5d62b640.svg";